import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  hardwaresGroup: []
}

export const mutations = {
  SET_HARDWARES_GROUP(state, hardwaresGroup) {
    state.hardwaresGroup = hardwaresGroup
  },
  ADD_HARDWARE_GROUP(state, hardwareGroup) {
    state.hardwaresGroup.push(hardwareGroup)
  },
  EDIT_HARDWARE_GROUP(state, hardwareGroup) {
    const index = state.hardwaresGroup.findIndex(
      e => e.hardware_group_uuid === hardwareGroup.hardware_group_uuid
    )
    if (index !== -1) {
      state.hardwaresGroup.splice(index, 1, hardwareGroup)
    }
  },
  DELETE_HARDWARE_GROUP(state, hardware_group_uuid) {
    const index = state.hardwaresGroup.findIndex(
      e => e.hardware_group_uuid === hardware_group_uuid
    )
    if (index !== -1) state.hardwaresGroup.splice(index, 1)
  }
}

export const actions = {
  fetchHardwaresGroup({ commit }, payload) {
    return ApiService.fetchHardwaresGroup(payload)
      .then(res => {
        const hardwaresGroup = res.data.data
        commit('SET_HARDWARES_GROUP', hardwaresGroup)
      })
      .catch(error => {
        throw error
      })
  },
  fetchHardwareGroupById({ commit }, payload) {
    return ApiService.fetchHardwareGroupById(payload)
      .then(res => {
        const hardwareGroup = res.data
        return hardwareGroup
      })
      .catch(error => {
        throw error
      })
  },
  addHardwareGroup({ commit }, payload) {
    return ApiService.addHardwareGroup(payload)
      .then(res => {
        const hardwareGroup = res.data
        commit('ADD_HARDWARE_GROUP', hardwareGroup)
        return hardwareGroup
      })
      .catch(error => {
        throw error
      })
  },
  editHardwareGroup({ commit }, payload) {
    return ApiService.editHardwareGroup(payload)
      .then(res => {
        const hardwareGroup = res.data
        commit('EDIT_HARDWARE_GROUP', hardwareGroup)
      })
      .catch(error => {
        throw error
      })
  },
  deleteHardwareGroup({ commit }, payload) {
    return ApiService.deleteHardwareGroup(payload)
      .then(() => {
        commit('DELETE_HARDWARE_GROUP', payload.hardware_group_uuid)
      })
      .catch(error => {
        throw error
      })
  },
  fetchHardwaresGroupMember({ commit }, payload) {
    return ApiService.fetchHardwaresGroupMember(payload)
      .then(res => {
        const hardwareGroupMember = res.data
        return hardwareGroupMember
      })
      .catch(error => {
        throw error
      })
  },
  addHardwareGroupMember({ commit }, payload) {
    return ApiService.addHardwareGroupMember(payload).catch(error => {
      throw error
    })
  },
  deleteHardwareGroupMember({ commit }, payload) {
    return ApiService.deleteHardwareGroupMember(payload).catch(error => {
      throw error
    })
  }
}
